const ticks = Array.from({ length: 120 }, (_, i) => i);
const spokes = Array.from({ length: 12 }, (_, i) => i);

export const Astrolabe = ({ className = "", reverse = false }) => (
  <svg viewBox="0 0 600 600" className={className} aria-hidden="true" fill="none" stroke="currentColor">
    <g className={reverse ? "spin-rev" : "spin-slow"} style={{ transformOrigin: "300px 300px" }}>
      <circle cx="300" cy="300" r="296" strokeWidth="0.6" />
      <circle cx="300" cy="300" r="278" strokeWidth="0.4" strokeDasharray="1 5" />
      {ticks.map((i) => (
        <line
          key={i}
          x1="300"
          y1={i % 10 === 0 ? 4 : 10}
          x2="300"
          y2="22"
          strokeWidth={i % 10 === 0 ? 0.9 : 0.4}
          transform={`rotate(${i * 3} 300 300)`}
        />
      ))}
      <circle cx="300" cy="300" r="240" strokeWidth="0.5" />
      {spokes.map((i) => (
        <line key={i} x1="300" y1="60" x2="300" y2="150" strokeWidth="0.35" transform={`rotate(${i * 30} 300 300)`} />
      ))}
    </g>
    <g className={reverse ? "spin-slow" : "spin-rev"} style={{ transformOrigin: "300px 300px" }}>
      <ellipse cx="300" cy="300" rx="200" ry="120" strokeWidth="0.45" />
      <ellipse cx="300" cy="300" rx="120" ry="200" strokeWidth="0.45" />
      <circle cx="300" cy="300" r="150" strokeWidth="0.4" strokeDasharray="2 8" />
      <circle cx="500" cy="300" r="3" fill="currentColor" stroke="none" />
      <circle cx="300" cy="100" r="2" fill="currentColor" stroke="none" />
    </g>
  </svg>
);
